export enum EDirection {
  Credit = 'Credit',
  Debit = 'Debit',
  Future = 'Debit'
}
